(function () {
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-sc-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  var CART_ENDPOINT_RE = /\/cart\/(add|update|change|clear)(\.js)?(\?|$)/;

  // Patch fetch so any app's AJAX add-to-cart call (bundles, quick-add, upsells, etc.)
  // triggers a badge refresh, regardless of who made the call.
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      var promise = origFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (CART_ENDPOINT_RE.test(url)) {
          promise.then(function (res) {
            if (res && res.ok) updateCartCount();
          });
        }
      } catch (e) {}
      return promise;
    };
  }

  // Patch XMLHttpRequest too, in case an app uses XHR instead of fetch.
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      if (CART_ENDPOINT_RE.test(url)) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) updateCartCount();
        });
      }
    } catch (e) {}
    return origOpen.apply(this, arguments);
  };

  // Also catch same-tab form submits to /cart/add (non-AJAX apps) and cross-tab updates.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.action && CART_ENDPOINT_RE.test(form.action)) {
      setTimeout(updateCartCount, 300);
    }
  });

  document.addEventListener('DOMContentLoaded', updateCartCount);
  window.addEventListener('pageshow', updateCartCount);

  window.scCartBadge = { update: updateCartCount };
})();
